

class CrossBrowserImages {

  constructor() {
    this.mediaQueryListObj = { mobile: "(max-width: 47.9375rem)", tablet: "(min-width: 48rem) and (max-width: 63.9375rem)", desktop: "(min-width: 64rem)" };
    this.testingMode = false;
  }

  /** 
   * React-specfic : Runs the crossbrowser implementation and sets the sliderImages (required) state.
   * Can be refactored for non-React use.
   */
  runCrossBrowser = (thisClass, data, images) => {
    let msg = { result: null, imgs: [] };
    const prodType = data.course_id ? { prod: data.course_id, tracker: thisClass.screenshotProdList.courses } :
      { prod: data.suite_id, tracker: thisClass.screenshotProdList.suites };
    if (prodType.tracker.length > 0) {
      if (prodType.tracker.includes(prodType.prod)) {
        msg.imgs = this.handleCrossBrowserImgs(thisClass, images);
        msg.result = `handledCbImg on ${data.course_id ? 'course_d' : 'suite_id'}`;
      } else {
        /* Otherwise, set non-crossbrowser images. */
        thisClass.setState({ sliderImages: images });
        msg.result = 'handledCbImg none';
      }
    } else {
      /* Otherwise, no tracker present. Set non-crossbrowser images. */
      thisClass.setState({ sliderImages: images });
      msg.mgs = 'handledCbImg none';
    }
    return msg;
  }

  /** 
   * React-specific - Handles the looping for changing all images that are present in
   * the images[] arg, and then sets the sliderImages (required) state.
   * Can be refactored for non-React use.
   */
  handleCrossBrowserImgs = (thisClass, images) => {
    const cbImgs = [];
    let x;
    if (images) {
      images.forEach(img => {
        x = Object.assign({}, img);
        x.image_file = this.handleImageChange(x.image_file);
        cbImgs.push(x);
      });
      thisClass.setState({ sliderImages: cbImgs });
    }
    return cbImgs;
  }

  /** 
   * React-specific switch that tracks the breaking points. The state values are used to
   * alter image names accordingly. The React class being used must have
   * the following states added: desktopTracker, tabletTracker, and mobileTracker.
   * Can be refactored for non-React use.
   */
  handleBrkPointCases(thisClass, bpoint) {
    switch (bpoint) {
      case 'desktop':
        thisClass.setState({ desktopTracker: 1, tabletTracker: 0, mobileTracker: 0 });
        break;
      case 'tablet':
        thisClass.setState({ desktopTracker: 0, tabletTracker: 1, mobileTracker: 0 });
        break;
      case 'mobile':
        thisClass.setState({ desktopTracker: 0, tabletTracker: 0, mobileTracker: 1 });
        break;
    }
  }

  /** Detects the current breaking point based on a media query object's properties. */
  detectBreakPoints = (mQobj = null) => {
    const result = {};
    if (mQobj === null && !this.testingMode) {
      mQobj = this.mediaQueryListObj;
    }
    if (mQobj === null && this.testingMode) {
      return false;
    }
    const brkPoints = Object.keys(mQobj);
    brkPoints.forEach(brkPnt => {
      const x = mQobj[brkPnt];
      result[brkPnt] = window.matchMedia(x).matches;
    });
    return result;
  }

  /** Changes out default image based on the current breaking point. */
  handleImageChange = (imgPath, currMediaState = null) => {
    if (currMediaState === null) {
      currMediaState = this.detectBreakPoints();
    }
    const i = this.handleImagePath(imgPath, currMediaState);
    return i;
  }

  /** Applies the proper naming convention to an image path based on the current media query. */
  handleImagePath = (imagePath, currMediaState) => {
    imagePath = imagePath.replace('course_screenshots', 'course-screenshots-cb');
    const pathParts = imagePath.split('.');
    const imgExt = pathParts[pathParts.length - 1];
    let fileName = imagePath.replace(`.${imgExt}`, '');
    if (currMediaState.mobile) {
      fileName = fileName + '-mobile';
    } else if (currMediaState.tablet) {
      fileName = fileName + '-tablet';
    } else {
      fileName = fileName + '-desktop';
    }
    fileName = fileName + `.${imgExt}`;
    return fileName;
  }
}

export default CrossBrowserImages;
